













import { HistoryTerm } from '@empathy/search-types';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';
import { wrapWithHTMLTag } from '../../../utils';
import AddClassToSlot from '../add-class-to-slot';

@Component({
  components: {
    AddClassToSlot
  }
})
export default class HistorySuggestion extends Vue {
  @Prop({ default: '' })
  suggestion: HistoryTerm;

  @Prop()
  selected: boolean;

  @Prop({ default: EVENTS.QueryHistoryTermSelected })
  event: string;

  @Prop()
  inputQuery?: string;

  get highlightedTermHTML(): string {
    return this.inputQuery
      ? wrapWithHTMLTag(this.suggestion.term, this.inputQuery, {
        tag: 'strong',
        className: 'ebx-suggestion__term-query'
      })
      : this.suggestion.term;
  }

  selectHistoryTerm() {
    this.$x.emit(this.event, this.suggestion);
  }

  removeHistoryTerm() {
    this.$x.emit(EVENTS.QueryHistoryTermRemoved, this.suggestion);
  }
}
